import { render, staticRenderFns } from "./FeatureBlockGroup.vue?vue&type=template&id=6ef63c5e&scoped=true&"
import script from "./FeatureBlockGroup.vue?vue&type=script&lang=ts&"
export * from "./FeatureBlockGroup.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureBlockGroup.vue?vue&type=style&index=0&id=6ef63c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef63c5e",
  null
  
)

export default component.exports